var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpand = function SvgExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    transform: "scale(-1 1)",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 8.59V4c0-.55-.45-1-1-1h-4.59c-.89 0-1.34 1.08-.71 1.71l1.59 1.59-10 10-1.59-1.59c-.62-.63-1.7-.19-1.7.7V20c0 .55.45 1 1 1h4.59c.89 0 1.34-1.08.71-1.71L7.71 17.7l10-10 1.59 1.59c.62.63 1.7.19 1.7-.7"
  })));
};
export { SvgExpand as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgZmlsbD0iY3VycmVudENvbG9yIiB0cmFuc2Zvcm09InNjYWxlKC0xIDEpIj48cGF0aCBkPSJNMjEgOC41OVY0YzAtLjU1LS40NS0xLTEtMWgtNC41OWMtLjg5IDAtMS4zNCAxLjA4LS43MSAxLjcxbDEuNTkgMS41OS0xMCAxMC0xLjU5LTEuNTljLS42Mi0uNjMtMS43LS4xOS0xLjcuN1YyMGMwIC41NS40NSAxIDEgMWg0LjU5Yy44OSAwIDEuMzQtMS4wOC43MS0xLjcxTDcuNzEgMTcuN2wxMC0xMCAxLjU5IDEuNTljLjYyLjYzIDEuNy4xOSAxLjctLjciLz48L3N2Zz4=";